import { useState } from 'react'
import { useStaffGetCommissionInfoForCampaign } from '@urbanx/agx.campaigns.client'
import {
  AgxButton,
  AgxServiceFeeTableView,
  AgxSpacer,
  AgxTypography,
  Icon_EditOutline,
} from '@urbanx/agx.ui-components2'
import Panel from 'components/panel/Panel'
import { CommissionMenu, FinanceMenu, MenuTitles } from 'constants/menu'
import { useSelectedCampaign } from 'hooks'
import { ContentLayout } from 'layout'
import ServiceFeeHistoryModal from './ServiceFeeHistoryModal'
import EditServiceFeeModal from './EditServiceFeeModal'
import { PartnershipDetailsPartnershipLevel } from '@urbanx/agx.agencies.client'

const ServiceFeePage = () => {
  const { campaign: selectedCampaign } = useSelectedCampaign()

  const { data: commissionBreakDown } = useStaffGetCommissionInfoForCampaign(
    selectedCampaign?.campaignId || '',
    !!selectedCampaign
  )

  const currentSericeFeeInfo = commissionBreakDown?.serviceFeeInformation
    ?.currentServiceFeeDetails ?? {
    serviceFeePercentage: commissionBreakDown?.defaultServiceFee,
    changeInfo: undefined,
  }

  const [isServiceFeeHistoryModalOpen, setIsServiceFeeHistoryModalOpen] =
    useState(false)
  const [isEditServiceFeeModal, setIsEditServiceFeeModalOpen] = useState(false)

  return (
    <ContentLayout
      hasSecondaryMenu={false}
      secondaryActiveMenu={MenuTitles.COMMISSION}
      secondaryMenuOverride={FinanceMenu}
      isCampaigns={true}
      tertiaryMenu={CommissionMenu}
      tertiaryActiveMenu={MenuTitles.COMMISSION_SERVICE_FEE}
      tertiaryTitle={'Commission'}
    >
      {isServiceFeeHistoryModalOpen && (
        <ServiceFeeHistoryModal
          onClose={() => setIsServiceFeeHistoryModalOpen(false)}
          serviceFeeInformation={commissionBreakDown?.serviceFeeInformation}
        />
      )}

      {isEditServiceFeeModal && (
        <EditServiceFeeModal
          partnershipLevel={
            commissionBreakDown?.partnershipLevel as unknown as PartnershipDetailsPartnershipLevel
          }
          onClose={() => setIsEditServiceFeeModalOpen(false)}
          currentServiceFeeDetails={currentSericeFeeInfo!}
        />
      )}

      <Panel
        title={
          <AgxTypography id="panel" type="title" size="large">
            Service Fee
          </AgxTypography>
        }
        padding={{
          top: 'spacing-3xl',
          bottom: 'spacing-3xl',
          left: 'spacing-5xl',
          right: 'spacing-5xl',
        }}
      >
        <AgxSpacer gap="spacing-3xl" fill>
          {currentSericeFeeInfo !== undefined && (
            <>
              <AgxServiceFeeTableView
                currentServiceFeeDetails={currentSericeFeeInfo}
                partnershipLevel={
                  commissionBreakDown?.partnershipLevel as unknown as PartnershipDetailsPartnershipLevel
                }
              />
              <AgxSpacer
                gap="spacing-xl"
                fill
                direction="horizontal"
                contentAlignment="center"
                contentJustification="end"
              >
                {commissionBreakDown?.serviceFeeInformation && (
                  <AgxButton
                    id={'ViewServiceFeeHistory'}
                    text={'View history'}
                    variant={'hollow'}
                    size="small"
                    onClick={() => setIsServiceFeeHistoryModalOpen(true)}
                  />
                )}
                <AgxButton
                  id={'editServiceFee'}
                  text={'Edit'}
                  variant={'hollow'}
                  size="small"
                  rightIcon={
                    <Icon_EditOutline color="var(--fg-brand-accent)" />
                  }
                  onClick={() => setIsEditServiceFeeModalOpen(true)}
                />
              </AgxSpacer>
            </>
          )}
        </AgxSpacer>
      </Panel>
    </ContentLayout>
  )
}

export default ServiceFeePage
